import React from "react";
import { TextField } from "@mui/material";

export const SlideUpModalInput = (props) => (
  <TextField
    variant="outlined"
    className="slide-up-modal-input"
    sx={{
      "& label": {
        fontFamily: '"proxima-nova", "sans-serif"',
      },
      "& label.Mui-focused": {
        color: "white",
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: "white",
      },
      "& .MuiOutlinedInput-root": {
        padding: "30px 20px 0px 20px",
        color: "white",
        "& fieldset": {
          border: "1px solid #FFFFFF11",
        },
        "&:hover fieldset": {
          border: "1px solid #FFFFFF11",
        },
        "&.Mui-focused fieldset": {
          border: "1px solid white",
        },
        "&.Mui-error fieldset": {
          border: "1px solid #FFFFFF30",
        },
      },
      "& .MuiInputBase-input": {
        paddingBottom: 0.5,
        marginBottom: 1.65,
        borderBottom: "1px solid #FFFFFF11",
        fontSize: 20,
        fontFamily: '"proxima-nova", "sans-serif"',
      },
      "& .MuiOutlinedInput-root.Mui-focused": {
        "& .MuiInputBase-input": {
          borderBottom: "1px solid white",
        },
      },
      "& .MuiFormHelperText-root.Mui-error": {
        color: "orange",
        fontWeight: "bold",
      },
      "& .MuiInputBase-input.MuiInputBase-inputMultiline": {
        marginTop: 1.65,
        lineHeight: 1.6,
        fontSize: "17px",
      },
    }}
    InputProps={{
      notched: false,
      multiline: props.multiline,
    }}
    InputLabelProps={{
      style: {
        paddingTop: 10,
        width: "100%",
        transform: "none",
        textAlign: "center",
        color: "white",
        fontWeight: "bold",
      },
      shrink: true,
    }}
    {...props}
  />
);
